export const controls = {
  point: true,
  polygon: true,
  combine_features: false,
  trash: true,
  uncombine_features: false,
  line_string: false,
}

export const cursorListeners = () => {
  let pointer = document.querySelector('.mapbox-gl-draw_point')
  let polygon = document.querySelector('.mapbox-gl-draw_polygon')
  let trash = document.querySelector('.mapbox-gl-draw_trash')

  pointer.addEventListener('click', () => {
    clearCursors()
    let mapboxCanvas = document.querySelector('.mapboxgl-canvas')
    pointer.classList.add('mapboxgl-canvas-pointer')
    mapboxCanvas.classList.add('mapboxgl-canvas-pointer')
  })

  polygon.addEventListener('click', () => {
    clearCursors()
    let mapboxCanvas = document.querySelector('.mapboxgl-canvas')
    polygon.classList.add('mapboxgl-canvas-polygon')
    mapboxCanvas.classList.add('mapboxgl-canvas-polygon')
  })

  trash.addEventListener('click', () => clearCursors())
}

export const clearCursors = () => {
  let pointer = document.querySelector('.mapbox-gl-draw_point')
  let polygon = document.querySelector('.mapbox-gl-draw_polygon')
  let mapboxCanvas = document.querySelector('.mapboxgl-canvas')

  mapboxCanvas.classList.remove('mapboxgl-canvas-polygon')
  mapboxCanvas.classList.remove('mapboxgl-canvas-pointer')
  polygon.classList.remove('mapboxgl-canvas-polygon')
  pointer.classList.remove('mapboxgl-canvas-pointer')
}



// WEBPACK FOOTER //
// ./src/components/Map/MapTools/utils/index.js